export default __webpack_public_path__ + "media/images/upload-53252844.svg";